import { data } from "autoprefixer";

// 店铺
export const shopList = [
    {
        title: '店铺',
        key: 'shop',
        data: [
            {
                title: '基础页面',
                data: [
                    {
                        id: 'cb344ba',
                        title: '店铺首页',
                        param: {
                            path: 'pages/index/index?pageId=0'
                        }
                    },
					
                    {
                        id: 'c37c2ee',
                        title: '店铺分类',
                        param: {
                            path: 'pages/category/index'
                        }
                    },
                    {
                        id: 'bb2f7f1',
                        title: '购物车',

                        param: {
                            path: 'pages/cart/index'
                        }
                    },
                    {
                        id: 'a013c9e',
                        title: '会员中心',
                        param: {
                            path: 'pages/index/me'
                            // path: 'pages/user/index'
                        }
                    },
                    {
                        id: 'a013yuc9e',
                        title: '堂食',
                        param: {
                            path: 'pages/other/dinein/index'
                            // path: 'pages/user/index'
                        }
                    },
                ]
            },
            {
                title: '商城页面',
                data: [
                    {
                        id: '88lxeey',
                        title: '商品搜索页',

                        param: {
                            path: 'pages/search/index'
                        }
                    },
                    {
                        id: '88lxeez',
                        title: '门店列表',
                        param: {
                            path: 'pages/store-more/list'
                        }
                    },
                    {
                        id: '593fe1f',
                        title: '会员登录页',

                        param: {
                            path: 'pages/login/index'
                        }
                    },
                    {
                        id: 'u1v6aus',
                        title: '扫一扫',

                        moduleKey: 'content-code',
                        param: {
                            path: 'pages/scan/index',
                            query: {}
                        },
                    },
					{
					    id: 'u1v2dus4',
					    title: '收藏商品列表',
					    moduleKey: 'content-collect-list',
					    param: {
					        path: 'pages/other/collect/list',
					        query: {}
					    },
					}
					// {
					//     id: 'u1v2dus',
					//     title: '即时通讯',
					//     moduleKey: 'content-tongxun',
					//     param: {
					//         path: 'uni_modules/uni-im/pages/contacts/contacts',
					//         query: {}
					//     },
					// }
                ]
            },
            {
                title: '会员中心',
                data: [
                    {
                        id: '7b345f6',
                        title: '我的订单',
                        param: {
                            path: 'pages/order/index',
                            query: {}
                        },
                    },
                    {
                        id: 'c4f630d',
                        title: '我的钱包',

                        param: {
                            path: 'pages/wallet/index'
                        }
                    },
                    {
                        id: '03b9290',
                        title: '我的礼券',

                        moduleKey: 'market-coupon',
                        param: {
                            path: 'pages/my-coupon/index'
                        }
                    },
                    {
                        id: '569b0b0',
                        title: '积分明细',

                        moduleKey: 'market-points',
                        param: {
                            path: 'pages/other/points/log'
                        }
                    },
                    {
                        id: '0c25051',
                        title: '收货地址',
                        param: {
                            path: 'pages/other/address/index'
                        }
                    },
                    {
                        id: '3558c27',
                        title: '帮助中心',
                        moduleKey: 'content-help',
                        param: {
                            path: 'pages/other/help/index'
                        }
                    },
					{
					    id: '3678c27',
					    title: '会员中心',
					    moduleKey: 'content-setting',
					    param: {
					        path: 'pages/other/setting/index'
					    }
					},
                ]
            },
			{
			    title: '订单数据',
			    data: [
			        {
			            id: '7b345f67',
			            title: '收银台订单',
			            param: {
			                path: 'pages/order/cashier/index',
			                query: {}
			            },
			        },
				]
			}
        ]
    },
    {
        title: '自定义页面',
        key: 'self',
    },
    {
        title: '商品分类',
        key: 'cate',
    },
    {
        title: '商品',
        key: 'commidy',
    },
	{
	    title: '投票',
	    key: 'vote',
	},
	{
	    title: '团单',
	    key: 'group',
	},
	{
	    title: '签到',
	    key: 'sign',
	},
    {
        title: '营销',
        key: 'marketing',
        data: [
            {
                title: '营销活动',
                data: [
                    {
                        id: '56sswhq',
                        title: '领券中心',

                        moduleKey: 'market-coupon',
                        param: {
                            path: 'pages/coupon/index' 
                        }
                    },
                    {
                        id: '792db19',
                        title: '充值中心',

                        moduleKey: 'market-recharge',
                        param: {
                            path: 'pages/wallet/recharge/index'
                        }
                    },
					{
					    id: '792dbe191',
					    title: '积分商城',
					    moduleKey: 'market-pointsmall',
					    param: {
					        path: 'pages/pointsCenter/pointsMall'
					    }
					},
					{
					    id: '792dbe1966',
					    title: '积分中心',
					    moduleKey: 'market-pointsmallc',
					    param: {
					        path: 'pages/pointsCenter/index'
					    }
					},
					{
					    id: '793d419',
					    title: '限时秒杀',
					    moduleKey: 'market-seckill',
					    param: {
					        path: 'pages/subPack/good/seckill'
					    }
					},
					{
					    id: '725d419',
					    title: '超值单品',
					    moduleKey: 'market-super',
					    param: {
					        path: 'pages/subPack/good/super'
					    }
					},
					{
					    id: '5850419',
					    title: '新客有礼',
					    moduleKey: 'market-super',
					    param: {
					        path: 'pages/subPack/coupon/newcume'
					    }
					},
					{
					    id: '5850420',
					    title: '付费会员',
					    moduleKey: 'market-paidcard',
					    param: {
					        path: 'pages/subPack/paidcard/index'
					    }
					},
					{
					    id: '58504ninegrid20',
					    title: '九宫格抽奖',
					    moduleKey: 'market-ninegrid',
					    param: {
					        path: 'pages/subapp/lottery/ninegrid'
					    }
					},
					{
					    id: '12476rcv57',
					    title: '我的团单',
					    moduleKey: 'market-group',
					    param: {
					        path: 'pages/subapp/group/order'
					    }
					},
					{
					    id: '124767rcv57',
					    title: '申请团长',
					    moduleKey: 'market-group-user',
					    param: {
					        path: 'pages/subapp/group/form'
					    }
					},
					{
					    id: 'ed45fee',
					    title: '余额明细',
					    moduleKey: 'market-yu-details',
					    param: {
					        path: 'pages/wallet/balance/log'
					    }
					},
					{
					    id: 'assist001',
					    title: '好友助力',
					    moduleKey: 'weishop_assist',
					    param: {
					        path: 'pages/subapp/assist/index'
					    }
					},
					{
					    id: 'ed45fesuue',
					    title: '消费红包',
					    moduleKey: 'market-redpack',
					    param: {
					        path: 'pages/subapp/redpack/index'
					    }
					},
					{
					    id: 'ed45ferf',
					    title: '裂变券',
					    moduleKey: 'market-fission-coupon',
					    param: {
					        path: 'pages/subapp/fission-coupon/index'
					    }
					},
                ]

            },
        ]
    },
    {
        title: '应用',
        key: 'app',
        data: [
            {
                title: '应用插件',
                data: [
                    {
                        id: 'ugrauzv',
                        title: '百问百答',
                        moduleKey: 'content-article',
                        param: {
                            path: 'pages/article/index',
                            query: {}
                        },

                    },
					{
					    id: 'ugrauzvw',
					    title: '商户入驻',
					    moduleKey: 'merchant-apply',
					    param: {
					        path: 'pages/subPack/merchant/loading',
					        query: {}
					    },
					
					},
					{
					    id: 'ugrauz6w',
					    title: '录播记录',
					    moduleKey: 'video-recording',
					    param: {
					        path: 'pages/subPack/video/recording',
					        query: {}
					    },
					},
					{
					    id: 'ugr1auzvw',
					    title: '多门店入驻',
					    moduleKey: 'merchant-apply',
					    param: {
					        path: 'pages/subapp/store/loading',
					        query: {}
					    },
					
					},
					{
					    id: 'cb344b1a',
					    title: '店铺申请入驻',
					    param: {
					        path: 'pages/subapp/store/loading'
					    }
					},
					{
					    id: 'ugrauzvws',
					    title: '通用表单',
					    moduleKey: 'common-form',
					    param: {
					        path: 'pages/subPack/form/index?scene=general',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzvwsg',
					    title: '数商中心',
					    moduleKey: 'content-dq',
					    param: {
					        path: 'pages/dq/become/index',
					        query: {}
					    },
					},
					{
					    id: 'ugradistributionuzvwsg',
					    title: '分销中心',
					    moduleKey: 'content-distribution',
					    param: {
					        path: 'pages/distribution/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrauareazvwsg',
					    title: '团队计酬',
					    moduleKey: 'content-area',
					    param: {
					        path: 'pages/area/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzvwarwsg',
					    title: '战略分红',
					    moduleKey: 'content-war',
					    param: {
					        path: 'pages/war/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzshareholdervwsg',
					    title: '股东分红',
					    moduleKey: 'content-shareholder',
					    param: {
					        path: 'pages/shareholder/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrachainuzvwsg',
					    title: '链动2+1',
					    moduleKey: 'content-chain',
					    param: {
					        path: 'pages/subPack/chain/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzwholevwsg',
					    title: '共享分红',
					    moduleKey: 'content-whole',
					    param: {
					        path: 'pages/whole/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzvlinkagewsg',
					    title: '组团联动',
					    moduleKey: 'content-linkage',
					    param: {
					        path: 'pages/subPack/linkage/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzvregionalwsg',
					    title: '区域代理',
					    moduleKey: 'content-dq',
					    param: {
					        path: 'pages/subPack/regional/applay',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzvwcuratorsg',
					    title: '店长提成',
					    moduleKey: 'content-curator',
					    param: {
					        path: 'pages/subPack/curator/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzvwholesalerwsg',
					    title: '批发商',
					    moduleKey: 'content-dq',
					    param: {
					        path: 'pages/subPack/wholesaler/apply',
					        query: {}
					    },
					},
					{
					    id: 'ugrauzvfestivalwsg',
					    title: '节日海报',
					    moduleKey: 'content-festival',
					    param: {
					        path: 'pages/subPack/festival/index',
					        query: {}
					    },
					},
					{
					    id: 'ugraudepositzvwsg',
					    title: '押金中心',
					    moduleKey: 'content-deposit',
					    param: {
					        path: 'pages/subapp/deposit/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrgiftcardsg',
					    title: '礼品卡',
					    moduleKey: 'content-giftcard',
					    param: {
					        path: 'pages/subapp/giftcard/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrgift345',
					    title: '账单中心',
					    moduleKey: 'content-order',
					    param: {
					        path: 'pages/order/center',
					        query: {}
					    },
					},
					{
					    id: 'ugrgift532',
					    title: '券包中心',
					    moduleKey: 'content-couponpackme',
					    param: {
					        path: 'pages/subPack/couponpack/me', 
					        query: {}
					    },
					},
					{
					    id: 'ugrgiwdr',
					    title: '兑换中心',
					    moduleKey: 'content-couponpackme',
					    param: {
					        path: 'pages/subPack/exchange/index',
					        query: {}
					    },
					},
					{
					    id: 'ugrg2iwdr',
					    title: '银行卡列表',
					    moduleKey: 'content-bank',
					    param: {
					        path: 'pages/bank/list',
					        query: {}
					    },
					},
					{
					    id: 'u4ertr',
					    title: '发布',
					    moduleKey: 'content-send',
					    param: {
					        path: 'pages/release/index',
					        query: {}
					    },
					},
					{
					    id: 'uuygr56r',
					    title: '发布订单',
					    moduleKey: 'content-sendorder',
					    param: {
					        path: 'pages/release/orderList',
					        query: {}
					    },
					},
					{
					    id: 'uu98fdr',
					    title: '积分市场',
					    moduleKey: 'content-pointsMarket',
					    param: {
					        path: 'pages/pointsMarket/index',
					        query: {}
					    },
					},
					{
					    id: 'uuiu674ff',
					    title: '推广员中心',
					    moduleKey: 'content-promoterCenter',
					    param: {
					        path: 'pages/subapp/promoter/index',
					        query: {}
					    },
					},
					{
					    id: 'uuiu65tgff',
					    title: '社区服务发布',
					    moduleKey: 'content-sqservice',
					    param: {
					        path: 'pages/release/index',
					        query: {}
					    },
					},
                ]
            },
			{
			    title: '生活服务师',
			    data: [
			        {
			            id: 'shenghuoshi1',
			            title: '师傅分类-服务师列表',
			            moduleKey: 'content-masterut',
			            param: {
			                path: 'pages/master/user',
			                query: {}
			            },
			
			        },
					{
					    id: 'shenghuoshi2',
					    title: '项目分组-服务师列表',
					    moduleKey: 'content-masterut',
					    param: {
					        path: 'pages/master/project',
					        query: {}
					    },
								
					},
					{
					    id: 'shenghuoshi3',
					    title: '订单列表',
					    moduleKey: 'content-masterut',
					    param: {
					        path: 'pages/master/order',
					        query: {}
					    },
					}
				]
			}
        ]
    },
    {
        title: '其他',
        key: 'other',
    },
	{
	    title: '门店分类',
	    key: 'store',
	},
]
